import { PayloadAction } from '@reduxjs/toolkit';
import { AppBundle } from 'api/optimalprint-sdk.d';
import { CategoryState } from 'store/category/types';

// add copy of parent to sidebarItems so that we can see parent as its own child
const setCurrentCategoryReducer = (
  state: CategoryState,
  action: PayloadAction<AppBundle.Api.Response.CategoryPage.V1.CategoryPageGetV1Response>,
) => {
  state.currentCategory = {
    ...action.payload,
    sidebarItems: action.payload.sidebarItems.map((sidebarItem) => {
      if (sidebarItem.childItems && sidebarItem.childItems.length > 0) {
        return {
          ...sidebarItem,
          childItems: [
            {
              text: sidebarItem.text,
              categoryId: sidebarItem.categoryId,
              url: sidebarItem.url,
            },
            ...sidebarItem.childItems,
          ],
        };
      }
      return sidebarItem;
    }),
  };
};

export default setCurrentCategoryReducer;
